import * as React from 'react';

import { LearningCoursesPage } from '@/imports/ui/pages/learning/LearningCoursesPage';
import { LearningPageShell } from '@/imports/ui/pages/learning/LearningPageShell';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

const LearningHomePage: React.FC = () => (
  <LearningPageShell>
    <LearningCoursesPage />
  </LearningPageShell>
);

export default restrictedRoute(LearningHomePage, {
  requiresSome: [RouteRestrictions.EVENTS_FEED_ACCESS],
});
